import { useEffect, useState } from "react";
import { api } from "../api/client";
import { Modal, FormGroup, Spinner, ConfirmModal } from "../components/UI";

export default function Mitglieder() {
  const [mitglieder, setMitglieder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editM, setEditM] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const emptyForm = { vorname: "", nachname: "", email: "", funktion: "", telefon: "", strasse: "", hausnummer: "", plz: "", ort: "", aktiv: true };
  const [form, setForm] = useState(emptyForm);

  const load = () => api.getMitglieder().then(setMitglieder).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (editM) await api.updateMitglied(editM.id, form);
    else await api.createMitglied(form);
    setShowForm(false); load();
  };

  const openEdit = (m) => {
    setForm({ vorname: m.vorname, nachname: m.nachname, email: m.email,
      funktion: m.funktion || "", telefon: m.telefon || "",
      strasse: m.strasse || "", hausnummer: m.hausnummer || "",
      plz: m.plz || "", ort: m.ort || "", aktiv: m.aktiv });
    setEditM(m); setShowForm(true);
  };

  const openNew = () => { setForm(emptyForm); setEditM(null); setShowForm(true); };

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const exportieren = async (m) => {
    const daten = await api.exportMitgliedDaten(m.id);
    const blob = new Blob([JSON.stringify(daten, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `datenexport_${m.vorname}_${m.nachname}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading) return <Spinner />;

  return (
    <div>
      <div className="page-header">
        <div><div className="breadcrumb">Verwaltung</div><h2>Mitglieder</h2></div>
        <div className="page-actions">
          <button className="btn btn-primary" onClick={openNew}>+ Mitglied anlegen</button>
        </div>
      </div>

      <div className="content">
        <div className="card">
          {mitglieder.length === 0 ? (
            <div className="empty-state"><div className="empty-icon">👤</div><p>Keine Mitglieder vorhanden</p></div>
          ) : (
            <table className="table">
              <thead>
                <tr><th>Name</th><th>Funktion</th><th>E-Mail</th><th>Telefon</th><th>Anschrift</th><th></th></tr>
              </thead>
              <tbody>
                {mitglieder.map(m => (
                  <tr key={m.id}>
                    <td><strong>{m.nachname}, {m.vorname}</strong></td>
                    <td style={{ color: "#666" }}>{m.funktion || "—"}</td>
                    <td style={{ fontFamily: "var(--mono)", fontSize: 13 }}>{m.email}</td>
                    <td style={{ fontSize: 13 }}>{m.telefon || "—"}</td>
                    <td style={{ fontSize: 13 }}>{m.strasse ? `${m.strasse} ${m.hausnummer}, ${m.plz} ${m.ort}` : "—"}</td>
                    <td>
                      <div className="actions">
                        <button className="btn btn-ghost btn-sm btn-icon" title="Bearbeiten" aria-label="Bearbeiten" onClick={() => openEdit(m)}>✎</button>
                        <button className="btn btn-ghost btn-sm btn-icon" title="Daten exportieren (DSGVO)" onClick={() => exportieren(m)}>⬇</button>
                        <button className="btn btn-ghost btn-sm btn-icon" title="Löschen" aria-label="Löschen" onClick={() => setDeleteId(m.id)}>🗑</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {showForm && (
        <Modal title={editM ? "Mitglied bearbeiten" : "Neues Mitglied"} onClose={() => setShowForm(false)}
          footer={<>
            <button className="btn btn-secondary" onClick={() => setShowForm(false)}>Abbrechen</button>
            <button className="btn btn-primary" onClick={save}>Speichern</button>
          </>}>
          <div className="form-row">
            <FormGroup label="Vorname *">
              <input className="form-control" value={form.vorname} onChange={e => set("vorname", e.target.value)} />
            </FormGroup>
            <FormGroup label="Nachname *">
              <input className="form-control" value={form.nachname} onChange={e => set("nachname", e.target.value)} />
            </FormGroup>
          </div>
          <FormGroup label="E-Mail *">
            <input type="email" className="form-control" value={form.email} onChange={e => set("email", e.target.value)} />
          </FormGroup>
          <div className="form-row">
            <FormGroup label="Funktion / Dienstgrad">
              <input className="form-control" value={form.funktion} placeholder="z. B. Wehrführer"
                onChange={e => set("funktion", e.target.value)} />
            </FormGroup>
            <FormGroup label="Telefon">
              <input className="form-control" value={form.telefon} placeholder="z. B. 0123 456789"
                onChange={e => set("telefon", e.target.value)} />
            </FormGroup>
          </div>
          <div className="form-row">
            <FormGroup label="Straße">
              <input className="form-control" value={form.strasse} onChange={e => set("strasse", e.target.value)} />
            </FormGroup>
            <FormGroup label="Nr." >
              <input className="form-control" value={form.hausnummer} onChange={e => set("hausnummer", e.target.value)} style={{ maxWidth: 80 }} />
            </FormGroup>
          </div>
          <div className="form-row">
            <FormGroup label="PLZ">
              <input className="form-control" value={form.plz} onChange={e => set("plz", e.target.value)} style={{ maxWidth: 100 }} />
            </FormGroup>
            <FormGroup label="Ort">
              <input className="form-control" value={form.ort} onChange={e => set("ort", e.target.value)} />
            </FormGroup>
          </div>
        </Modal>
      )}

      {deleteId && (
        <ConfirmModal
          message="Mitglied wirklich deaktivieren?"
          onConfirm={async () => { await api.deleteMitglied(deleteId); load(); }}
          onClose={() => setDeleteId(null)}
        />
      )}
    </div>
  );
}
